import * as read_api from "./alan_api";
function serialize_collection_query_entries($_collection_query_entries: read_api.Ccollection_query_entries) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_collection_query_entries.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__collection_query_entries = $_collection_query_entries.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["properties"] = serialize_node_query_result($_no__has_steps__collection_query_entries.properties.properties);
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__collection_query_entries = $_collection_query_entries.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				const raw_entries: Record<string, any> = {};
				for (let [k,v] of $_yes__has_steps__collection_query_entries.properties.entries) {
					const $_entries__yes = v;
					const raw_data: Record<string, any> = {};
					raw_data["tail"] = serialize_collection_query_entries($_entries__yes.properties.tail);
					{
						let raw_type: Record<string, any>;
						switch ($_entries__yes.properties.type.state.name) {
							case 'candidate': {
								const $_candidate = $_entries__yes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_reference_result: Record<string, any>;
									switch ($_candidate.properties.reference_result.state.name) {
										case 'no': {
											const $_no__reference_result__candidate = $_candidate.properties.reference_result.state.node;
											const raw_data: Record<string, any> = {};
											raw_reference_result = raw_data
											break;
										}
										case 'yes': {
											const $_yes__reference_result__candidate = $_candidate.properties.reference_result.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["id path"] = serialize_id_path($_yes__reference_result__candidate.properties.id_path);
											raw_reference_result = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_candidate.properties.reference_result.state)
									}
									raw_data["reference result"] = [$_candidate.properties.reference_result.state.name, raw_reference_result];
								}
								raw_type = raw_data
								break;
							}
							case 'existing entry': {
								const $_existing_entry = $_entries__yes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_entries__yes.properties.type.state)
						}
						raw_data["type"] = [$_entries__yes.properties.type.state.name, raw_type];
					}
					raw_entries[k] = raw_data
				}
				raw_data["entries"] = raw_entries;
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_collection_query_entries.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_collection_query_entries.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_entry_points($_entry_points: read_api.Centry_points) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_entry_points.properties.type.state.name) {
			case 'collection': {
				const $_collection__type__entry_points = $_entry_points.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				const raw_entries: Record<string, any> = {};
				for (let [k,v] of $_collection__type__entry_points.properties.entries) {
					const $_entries__collection__type__entry_points = v;
					const raw_data: Record<string, any> = {};
					raw_data["entry points"] = serialize_entry_points($_entries__collection__type__entry_points.properties.entry_points);
					raw_entries[k] = raw_data
				}
				raw_data["entries"] = raw_entries;
				raw_type = raw_data
				break;
			}
			case 'query': {
				const $_query = $_entry_points.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				const raw_flat_graph: Record<string, any> = {};
				for (let [k,v] of $_query.properties.flat_graph) {
					const $_flat_graph = v;
					const raw_data: Record<string, any> = {};
					raw_data["count"] = $_flat_graph.properties.count.value;
					raw_data["entries"] = serialize_list_query_result_entries($_flat_graph.properties.entries);
					raw_flat_graph[k] = raw_data
				}
				raw_data["flat graph"] = raw_flat_graph;
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_entry_points.properties.type.state)
		}
		raw_data["type"] = [$_entry_points.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_graph_node($_graph_node: read_api.Cgraph_node) {
	const raw_data: Record<string, any> = {};
	const raw_children: Record<string, any> = {};
	for (let [k,v] of $_graph_node.properties.children) {
		const $_children = v;
		const raw_data: Record<string, any> = {};
		raw_data["graph"] = serialize_graph_node($_children.properties.graph);
		raw_data["link count"] = $_children.properties.link_count.value;
		raw_children[k] = raw_data
	}
	raw_data["children"] = raw_children;
	return raw_data;
}
function serialize_id_path($_id_path__client_reply: read_api.Cid_path__client_reply) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_id_path__client_reply.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__id_path = $_id_path__client_reply.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__id_path = $_id_path__client_reply.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_id_path($_yes__has_steps__id_path.properties.tail);
				{
					let raw_type: Record<string, any>;
					switch ($_yes__has_steps__id_path.properties.type.state.name) {
						case 'collection entry': {
							const $_collection_entry = $_yes__has_steps__id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["collection"] = $_collection_entry.properties.collection.entry;
							raw_data["id"] = $_collection_entry.properties.id;
							raw_type = raw_data
							break;
						}
						case 'group': {
							const $_group__type__yes = $_yes__has_steps__id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["group"] = $_group__type__yes.properties.group.entry;
							raw_type = raw_data
							break;
						}
						case 'state': {
							const $_state = $_yes__has_steps__id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["state"] = $_state.properties.state.entry;
							raw_data["state group"] = $_state.properties.state_group.entry;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_steps__id_path.properties.type.state)
					}
					raw_data["type"] = [$_yes__has_steps__id_path.properties.type.state.name, raw_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_id_path__client_reply.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_id_path__client_reply.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_list_query_result_entries($_list_query_result_entries: read_api.Clist_query_result_entries) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_list_query_result_entries.properties.type.state.name) {
			case 'collection': {
				const $_collection__type__list_query_result_entries = $_list_query_result_entries.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				const raw_entries: Record<string, any> = {};
				for (let [k,v] of $_collection__type__list_query_result_entries.properties.entries) {
					const $_entries__collection__type__list_query_result_entries = v;
					const raw_data: Record<string, any> = {};
					raw_data["result"] = serialize_list_query_result_entries($_entries__collection__type__list_query_result_entries.properties.result);
					raw_entries[k] = raw_data
				}
				raw_data["entries"] = raw_entries;
				raw_type = raw_data
				break;
			}
			case 'node': {
				const $_node__type = $_list_query_result_entries.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				const raw_properties: Record<string, any> = {};
				for (let [k,v] of $_node__type.properties.properties) {
					const $_properties__node = v;
					const raw_data: Record<string, any> = {};
					{
						let raw_is_set: Record<string, any>;
						switch ($_properties__node.properties.is_set.state.name) {
							case 'no': {
								const $_no__is_set = $_properties__node.properties.is_set.state.node;
								const raw_data: Record<string, any> = {};
								raw_is_set = raw_data
								break;
							}
							case 'yes': {
								const $_yes__is_set = $_properties__node.properties.is_set.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_type: Record<string, any>;
									switch ($_yes__is_set.properties.type.state.name) {
										case 'number': {
											const $_number__type__yes = $_yes__is_set.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["value"] = $_number__type__yes.properties.value.value;
											raw_type = raw_data
											break;
										}
										case 'state group': {
											const $_state_group__type__yes = $_yes__is_set.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["state"] = $_state_group__type__yes.properties.state.entry;
											raw_type = raw_data
											break;
										}
										case 'text': {
											const $_text__type__yes = $_yes__is_set.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["value"] = $_text__type__yes.properties.value;
											raw_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__is_set.properties.type.state)
									}
									raw_data["type"] = [$_yes__is_set.properties.type.state.name, raw_type];
								}
								raw_is_set = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_properties__node.properties.is_set.state)
						}
						raw_data["is set"] = [$_properties__node.properties.is_set.state.name, raw_is_set];
					}
					raw_properties[k] = raw_data
				}
				raw_data["properties"] = raw_properties;
				raw_type = raw_data
				break;
			}
			case 'none': {
				const $_none__type = $_list_query_result_entries.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_list_query_result_entries.properties.type.state)
		}
		raw_data["type"] = [$_list_query_result_entries.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_node_query_result($_node_query_result: read_api.Cnode_query_result) {
	const raw_data: Record<string, any> = {};
	const raw_properties: Record<string, any> = {};
	for (let [k,v] of $_node_query_result.properties.properties) {
		const $_properties__node_query_result = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_result: Record<string, any>;
			switch ($_properties__node_query_result.properties.result.state.name) {
				case 'does not exist': {
					const $_does_not_exist__result = $_properties__node_query_result.properties.result.state.node;
					const raw_data: Record<string, any> = {};
					raw_result = raw_data
					break;
				}
				case 'exists': {
					const $_exists__result = $_properties__node_query_result.properties.result.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_type: Record<string, any>;
						switch ($_exists__result.properties.type.state.name) {
							case 'collection': {
								const $_collection__type__exists = $_exists__result.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								const raw_entries: Record<string, any> = {};
								for (let [k,v] of $_collection__type__exists.properties.entries) {
									const $_entries__collection__type__exists = v;
									const raw_data: Record<string, any> = {};
									raw_data["properties"] = serialize_node_query_result($_entries__collection__type__exists.properties.properties);
									raw_entries[k] = raw_data
								}
								raw_data["entries"] = raw_entries;
								{
									let raw_has_graph_endpoints: Record<string, any>;
									switch ($_collection__type__exists.properties.has_graph_endpoints.state.name) {
										case 'no': {
											const $_no__has_graph_endpoints = $_collection__type__exists.properties.has_graph_endpoints.state.node;
											const raw_data: Record<string, any> = {};
											raw_has_graph_endpoints = raw_data
											break;
										}
										case 'yes': {
											const $_yes__has_graph_endpoints = $_collection__type__exists.properties.has_graph_endpoints.state.node;
											const raw_data: Record<string, any> = {};
											const raw_ordered_graphs: Record<string, any> = {};
											for (let [k,v] of $_yes__has_graph_endpoints.properties.ordered_graphs) {
												const $_ordered_graphs = v;
												const raw_data: Record<string, any> = {};
												raw_data["sink"] = $_ordered_graphs.properties.sink;
												raw_data["source"] = $_ordered_graphs.properties.source;
												raw_ordered_graphs[k] = raw_data
											}
											raw_data["ordered graphs"] = raw_ordered_graphs;
											raw_has_graph_endpoints = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection__type__exists.properties.has_graph_endpoints.state)
									}
									raw_data["has graph endpoints"] = [$_collection__type__exists.properties.has_graph_endpoints.state.name, raw_has_graph_endpoints];
								}
								raw_type = raw_data
								break;
							}
							case 'file': {
								const $_file__type__exists = $_exists__result.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["extension"] = $_file__type__exists.properties.extension;
								raw_data["token"] = $_file__type__exists.properties.token;
								raw_type = raw_data
								break;
							}
							case 'id path': {
								const $_id_path__type = $_exists__result.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["id path"] = serialize_id_path($_id_path__type.properties.id_path);
								raw_type = raw_data
								break;
							}
							case 'number': {
								const $_number__type__exists = $_exists__result.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["value"] = $_number__type__exists.properties.value.value;
								raw_type = raw_data
								break;
							}
							case 'state group': {
								const $_state_group__type__exists = $_exists__result.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["state"] = $_state_group__type__exists.properties.state.entry;
								raw_type = raw_data
								break;
							}
							case 'text': {
								const $_text__type__exists = $_exists__result.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["value"] = $_text__type__exists.properties.value;
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_exists__result.properties.type.state)
						}
						raw_data["type"] = [$_exists__result.properties.type.state.name, raw_type];
					}
					raw_result = raw_data
					break;
				}
				case 'permission denied': {
					const $_permission_denied__result__properties = $_properties__node_query_result.properties.result.state.node;
					const raw_data: Record<string, any> = {};
					raw_result = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_properties__node_query_result.properties.result.state)
			}
			raw_data["result"] = [$_properties__node_query_result.properties.result.state.name, raw_result];
		}
		raw_properties[k] = raw_data
	}
	raw_data["properties"] = raw_properties;
	return raw_data;
}
function serialize_notification_data($_notification_data: read_api.Cnotification_data) {
	const raw_data: Record<string, any> = {};
	const raw_properties: Record<string, any> = {};
	for (let [k,v] of $_notification_data.properties.properties) {
		const $_properties__notification_data = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_type: Record<string, any>;
			switch ($_properties__notification_data.properties.type.state.name) {
				case 'collection': {
					const $_collection__type__properties = $_properties__notification_data.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_graph_endpoints_update: Record<string, any>;
						switch ($_collection__type__properties.properties.graph_endpoints_update.state.name) {
							case 'no': {
								const $_no__graph_endpoints_update = $_collection__type__properties.properties.graph_endpoints_update.state.node;
								const raw_data: Record<string, any> = {};
								raw_graph_endpoints_update = raw_data
								break;
							}
							case 'yes': {
								const $_yes__graph_endpoints_update = $_collection__type__properties.properties.graph_endpoints_update.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_result: Record<string, any>;
									switch ($_yes__graph_endpoints_update.properties.result.state.name) {
										case 'endpoints': {
											const $_endpoints__result__yes__graph_endpoints_update = $_yes__graph_endpoints_update.properties.result.state.node;
											const raw_data: Record<string, any> = {};
											const raw_graph_endpoints: Record<string, any> = {};
											for (let [k,v] of $_endpoints__result__yes__graph_endpoints_update.properties.graph_endpoints) {
												const $_graph_endpoints__endpoints__result__yes__graph_endpoints_update = v;
												const raw_data: Record<string, any> = {};
												raw_data["sink"] = $_graph_endpoints__endpoints__result__yes__graph_endpoints_update.properties.sink;
												raw_data["source"] = $_graph_endpoints__endpoints__result__yes__graph_endpoints_update.properties.source;
												raw_graph_endpoints[k] = raw_data
											}
											raw_data["graph endpoints"] = raw_graph_endpoints;
											raw_result = raw_data
											break;
										}
										case 'none': {
											const $_none__result__yes__graph_endpoints_update = $_yes__graph_endpoints_update.properties.result.state.node;
											const raw_data: Record<string, any> = {};
											raw_result = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__graph_endpoints_update.properties.result.state)
									}
									raw_data["result"] = [$_yes__graph_endpoints_update.properties.result.state.name, raw_result];
								}
								raw_graph_endpoints_update = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_collection__type__properties.properties.graph_endpoints_update.state)
						}
						raw_data["graph endpoints update"] = [$_collection__type__properties.properties.graph_endpoints_update.state.name, raw_graph_endpoints_update];
					}
					{
						let raw_value_update: Record<string, any>;
						switch ($_collection__type__properties.properties.value_update.state.name) {
							case 'entries': {
								const $_entries__value_update = $_collection__type__properties.properties.value_update.state.node;
								const raw_data: Record<string, any> = {};
								const raw_entries: Record<string, any> = {};
								for (let [k,v] of $_entries__value_update.properties.entries) {
									const $_entries__entries__value_update = v;
									const raw_data: Record<string, any> = {};
									{
										let raw_type: Record<string, any>;
										switch ($_entries__entries__value_update.properties.type.state.name) {
											case 'create': {
												const $_create = $_entries__entries__value_update.properties.type.state.node;
												const raw_data: Record<string, any> = {};
												raw_data["delete permitted"] = serialize_permission_data($_create.properties.delete_permitted);
												raw_data["node data"] = serialize_subscription_result_data($_create.properties.node_data);
												raw_type = raw_data
												break;
											}
											case 'remove': {
												const $_remove = $_entries__entries__value_update.properties.type.state.node;
												const raw_data: Record<string, any> = {};
												raw_type = raw_data
												break;
											}
											case 'update': {
												const $_update__type__entries = $_entries__entries__value_update.properties.type.state.node;
												const raw_data: Record<string, any> = {};
												raw_data["node data"] = serialize_notification_data($_update__type__entries.properties.node_data);
												raw_type = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_entries__entries__value_update.properties.type.state)
										}
										raw_data["type"] = [$_entries__entries__value_update.properties.type.state.name, raw_type];
									}
									raw_entries[k] = raw_data
								}
								raw_data["entries"] = raw_entries;
								raw_value_update = raw_data
								break;
							}
							case 'no': {
								const $_no__value_update__collection = $_collection__type__properties.properties.value_update.state.node;
								const raw_data: Record<string, any> = {};
								raw_value_update = raw_data
								break;
							}
							case 'updated': {
								const $_updated = $_collection__type__properties.properties.value_update.state.node;
								const raw_data: Record<string, any> = {};
								raw_value_update = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_collection__type__properties.properties.value_update.state)
						}
						raw_data["value update"] = [$_collection__type__properties.properties.value_update.state.name, raw_value_update];
					}
					raw_type = raw_data
					break;
				}
				case 'file': {
					const $_file__type__properties = $_properties__notification_data.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["extension"] = $_file__type__properties.properties.extension;
					raw_data["token"] = $_file__type__properties.properties.token;
					raw_type = raw_data
					break;
				}
				case 'group': {
					const $_group__type__properties = $_properties__notification_data.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["notification data"] = serialize_notification_data($_group__type__properties.properties.notification_data);
					raw_type = raw_data
					break;
				}
				case 'number': {
					const $_number__type__properties = $_properties__notification_data.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["value"] = $_number__type__properties.properties.value.value;
					raw_type = raw_data
					break;
				}
				case 'state group': {
					const $_state_group__type__properties = $_properties__notification_data.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["state"] = $_state_group__type__properties.properties.state.entry;
					{
						let raw_type: Record<string, any>;
						switch ($_state_group__type__properties.properties.type.state.name) {
							case 'set': {
								const $_set = $_state_group__type__properties.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["delete permitted"] = serialize_permission_data($_set.properties.delete_permitted);
								raw_data["initialization data"] = serialize_subscription_result_data($_set.properties.initialization_data);
								raw_type = raw_data
								break;
							}
							case 'update': {
								const $_update__type__state_group = $_state_group__type__properties.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["notification data"] = serialize_notification_data($_update__type__state_group.properties.notification_data);
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_state_group__type__properties.properties.type.state)
						}
						raw_data["type"] = [$_state_group__type__properties.properties.type.state.name, raw_type];
					}
					raw_type = raw_data
					break;
				}
				case 'text': {
					const $_text__type__properties = $_properties__notification_data.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_reference_update: Record<string, any>;
						switch ($_text__type__properties.properties.reference_update.state.name) {
							case 'no': {
								const $_no__reference_update = $_text__type__properties.properties.reference_update.state.node;
								const raw_data: Record<string, any> = {};
								raw_reference_update = raw_data
								break;
							}
							case 'yes': {
								const $_yes__reference_update = $_text__type__properties.properties.reference_update.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_result: Record<string, any>;
									switch ($_yes__reference_update.properties.result.state.name) {
										case 'disconnected': {
											const $_disconnected__result__yes__reference_update = $_yes__reference_update.properties.result.state.node;
											const raw_data: Record<string, any> = {};
											raw_result = raw_data
											break;
										}
										case 'node': {
											const $_node__result__yes__reference_update = $_yes__reference_update.properties.result.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["id path"] = serialize_id_path($_node__result__yes__reference_update.properties.id_path);
											raw_result = raw_data
											break;
										}
										case 'permission denied': {
											const $_permission_denied__result__yes__reference_update = $_yes__reference_update.properties.result.state.node;
											const raw_data: Record<string, any> = {};
											raw_result = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_yes__reference_update.properties.result.state)
									}
									raw_data["result"] = [$_yes__reference_update.properties.result.state.name, raw_result];
								}
								raw_reference_update = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_text__type__properties.properties.reference_update.state)
						}
						raw_data["reference update"] = [$_text__type__properties.properties.reference_update.state.name, raw_reference_update];
					}
					{
						let raw_value_update: Record<string, any>;
						switch ($_text__type__properties.properties.value_update.state.name) {
							case 'no': {
								const $_no__value_update__text = $_text__type__properties.properties.value_update.state.node;
								const raw_data: Record<string, any> = {};
								raw_value_update = raw_data
								break;
							}
							case 'yes': {
								const $_yes__value_update = $_text__type__properties.properties.value_update.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["value"] = $_yes__value_update.properties.value;
								raw_value_update = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_text__type__properties.properties.value_update.state)
						}
						raw_data["value update"] = [$_text__type__properties.properties.value_update.state.name, raw_value_update];
					}
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_properties__notification_data.properties.type.state)
			}
			raw_data["type"] = [$_properties__notification_data.properties.type.state.name, raw_type];
		}
		raw_properties[k] = raw_data
	}
	raw_data["properties"] = raw_properties;
	return raw_data;
}
function serialize_permission_data($_permission_data: read_api.Cpermission_data) {
	const raw_data: Record<string, any> = {};
	{
		let raw_permitted: Record<string, any>;
		switch ($_permission_data.properties.permitted.state.name) {
			case 'no': {
				const $_no__permitted = $_permission_data.properties.permitted.state.node;
				const raw_data: Record<string, any> = {};
				raw_permitted = raw_data
				break;
			}
			case 'yes': {
				const $_yes__permitted = $_permission_data.properties.permitted.state.node;
				const raw_data: Record<string, any> = {};
				raw_permitted = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_permission_data.properties.permitted.state)
		}
		raw_data["permitted"] = [$_permission_data.properties.permitted.state.name, raw_permitted];
	}
	return raw_data;
}
function serialize_subscription_result_data($_subscription_result_data: read_api.Csubscription_result_data) {
	const raw_data: Record<string, any> = {};
	{
		let raw_read_permitted: Record<string, any>;
		switch ($_subscription_result_data.properties.read_permitted.state.name) {
			case 'no': {
				const $_no__read_permitted = $_subscription_result_data.properties.read_permitted.state.node;
				const raw_data: Record<string, any> = {};
				raw_read_permitted = raw_data
				break;
			}
			case 'yes': {
				const $_yes__read_permitted = $_subscription_result_data.properties.read_permitted.state.node;
				const raw_data: Record<string, any> = {};
				const raw_attributes: Record<string, any> = {};
				for (let [k,v] of $_yes__read_permitted.properties.attributes) {
					const $_attributes = v;
					const raw_data: Record<string, any> = {};
					{
						let raw_type: Record<string, any>;
						switch ($_attributes.properties.type.state.name) {
							case 'command': {
								const $_command = $_attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["execute permitted"] = serialize_permission_data($_command.properties.execute_permitted);
								raw_type = raw_data
								break;
							}
							case 'property': {
								const $_property = $_attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_type: Record<string, any>;
									switch ($_property.properties.type.state.name) {
										case 'collection': {
											const $_collection__type__property = $_property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["create permitted"] = serialize_permission_data($_collection__type__property.properties.create_permitted);
											{
												let raw_graph_endpoints_result: Record<string, any>;
												switch ($_collection__type__property.properties.graph_endpoints_result.state.name) {
													case 'no': {
														const $_no__graph_endpoints_result = $_collection__type__property.properties.graph_endpoints_result.state.node;
														const raw_data: Record<string, any> = {};
														raw_graph_endpoints_result = raw_data
														break;
													}
													case 'yes': {
														const $_yes__graph_endpoints_result = $_collection__type__property.properties.graph_endpoints_result.state.node;
														const raw_data: Record<string, any> = {};
														{
															let raw_result: Record<string, any>;
															switch ($_yes__graph_endpoints_result.properties.result.state.name) {
																case 'endpoints': {
																	const $_endpoints__result__yes__graph_endpoints_result = $_yes__graph_endpoints_result.properties.result.state.node;
																	const raw_data: Record<string, any> = {};
																	const raw_graph_endpoints: Record<string, any> = {};
																	for (let [k,v] of $_endpoints__result__yes__graph_endpoints_result.properties.graph_endpoints) {
																		const $_graph_endpoints__endpoints__result__yes__graph_endpoints_result = v;
																		const raw_data: Record<string, any> = {};
																		raw_data["sink"] = $_graph_endpoints__endpoints__result__yes__graph_endpoints_result.properties.sink;
																		raw_data["source"] = $_graph_endpoints__endpoints__result__yes__graph_endpoints_result.properties.source;
																		raw_graph_endpoints[k] = raw_data
																	}
																	raw_data["graph endpoints"] = raw_graph_endpoints;
																	raw_result = raw_data
																	break;
																}
																case 'none': {
																	const $_none__result__yes__graph_endpoints_result = $_yes__graph_endpoints_result.properties.result.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_result = raw_data
																	break;
																}
																default:
																	throw new Error("unexpected state: " + $_yes__graph_endpoints_result.properties.result.state)
															}
															raw_data["result"] = [$_yes__graph_endpoints_result.properties.result.state.name, raw_result];
														}
														raw_graph_endpoints_result = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_collection__type__property.properties.graph_endpoints_result.state)
												}
												raw_data["graph endpoints result"] = [$_collection__type__property.properties.graph_endpoints_result.state.name, raw_graph_endpoints_result];
											}
											{
												let raw_result: Record<string, any>;
												switch ($_collection__type__property.properties.result.state.name) {
													case 'entries': {
														const $_entries__result = $_collection__type__property.properties.result.state.node;
														const raw_data: Record<string, any> = {};
														const raw_entries: Record<string, any> = {};
														for (let [k,v] of $_entries__result.properties.entries) {
															const $_entries__entries__result = v;
															const raw_data: Record<string, any> = {};
															raw_data["delete permitted"] = serialize_permission_data($_entries__entries__result.properties.delete_permitted);
															raw_data["node data"] = serialize_subscription_result_data($_entries__entries__result.properties.node_data);
															raw_entries[k] = raw_data
														}
														raw_data["entries"] = raw_entries;
														raw_result = raw_data
														break;
													}
													case 'update': {
														const $_update__result = $_collection__type__property.properties.result.state.node;
														const raw_data: Record<string, any> = {};
														raw_result = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_collection__type__property.properties.result.state)
												}
												raw_data["result"] = [$_collection__type__property.properties.result.state.name, raw_result];
											}
											raw_type = raw_data
											break;
										}
										case 'file': {
											const $_file__type__property = $_property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["extension"] = $_file__type__property.properties.extension;
											raw_data["token"] = $_file__type__property.properties.token;
											raw_type = raw_data
											break;
										}
										case 'group': {
											const $_group__type__property = $_property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["node data"] = serialize_subscription_result_data($_group__type__property.properties.node_data);
											raw_type = raw_data
											break;
										}
										case 'number': {
											const $_number__type__property = $_property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["value"] = $_number__type__property.properties.value.value;
											raw_type = raw_data
											break;
										}
										case 'state group': {
											const $_state_group__type__property = $_property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											const raw_create_permitted: Record<string, any> = {};
											for (let [k,v] of $_state_group__type__property.properties.create_permitted) {
												const $_create_permitted = v;
												const raw_data: Record<string, any> = {};
												raw_create_permitted[k] = raw_data
											}
											raw_data["create permitted"] = raw_create_permitted;
											raw_data["delete permitted"] = serialize_permission_data($_state_group__type__property.properties.delete_permitted);
											raw_data["node data"] = serialize_subscription_result_data($_state_group__type__property.properties.node_data);
											raw_data["state"] = $_state_group__type__property.properties.state.entry;
											raw_type = raw_data
											break;
										}
										case 'text': {
											const $_text__type__property = $_property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_reference_result: Record<string, any>;
												switch ($_text__type__property.properties.reference_result.state.name) {
													case 'no': {
														const $_no__reference_result__text = $_text__type__property.properties.reference_result.state.node;
														const raw_data: Record<string, any> = {};
														raw_reference_result = raw_data
														break;
													}
													case 'yes': {
														const $_yes__reference_result__text = $_text__type__property.properties.reference_result.state.node;
														const raw_data: Record<string, any> = {};
														{
															let raw_result: Record<string, any>;
															switch ($_yes__reference_result__text.properties.result.state.name) {
																case 'disconnected': {
																	const $_disconnected__result__yes__reference_result = $_yes__reference_result__text.properties.result.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_result = raw_data
																	break;
																}
																case 'node': {
																	const $_node__result__yes__reference_result = $_yes__reference_result__text.properties.result.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_data["id path"] = serialize_id_path($_node__result__yes__reference_result.properties.id_path);
																	raw_result = raw_data
																	break;
																}
																case 'permission denied': {
																	const $_permission_denied__result__yes__reference_result = $_yes__reference_result__text.properties.result.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_result = raw_data
																	break;
																}
																default:
																	throw new Error("unexpected state: " + $_yes__reference_result__text.properties.result.state)
															}
															raw_data["result"] = [$_yes__reference_result__text.properties.result.state.name, raw_result];
														}
														raw_reference_result = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_text__type__property.properties.reference_result.state)
												}
												raw_data["reference result"] = [$_text__type__property.properties.reference_result.state.name, raw_reference_result];
											}
											raw_data["value"] = $_text__type__property.properties.value;
											raw_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_property.properties.type.state)
									}
									raw_data["type"] = [$_property.properties.type.state.name, raw_type];
								}
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_attributes.properties.type.state)
						}
						raw_data["type"] = [$_attributes.properties.type.state.name, raw_type];
					}
					raw_attributes[k] = raw_data
				}
				raw_data["attributes"] = raw_attributes;
				raw_read_permitted = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_subscription_result_data.properties.read_permitted.state)
		}
		raw_data["read permitted"] = [$_subscription_result_data.properties.read_permitted.state.name, raw_read_permitted];
	}
	raw_data["update permitted"] = serialize_permission_data($_subscription_result_data.properties.update_permitted);
	return raw_data;
}
export function serialize($_client_reply: read_api.Cclient_reply) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_client_reply.properties.type.state.name) {
			case 'acyclic graph list query': {
				const $_acyclic_graph_list_query = $_client_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_context: Record<string, any>;
					switch ($_acyclic_graph_list_query.properties.context.state.name) {
						case 'does not exist': {
							const $_does_not_exist__context__acyclic_graph_list_query = $_acyclic_graph_list_query.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						case 'exists': {
							const $_exists__context__acyclic_graph_list_query = $_acyclic_graph_list_query.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["entry points"] = serialize_entry_points($_exists__context__acyclic_graph_list_query.properties.entry_points);
							raw_context = raw_data
							break;
						}
						case 'permission denied': {
							const $_permission_denied__context__acyclic_graph_list_query = $_acyclic_graph_list_query.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_acyclic_graph_list_query.properties.context.state)
					}
					raw_data["context"] = [$_acyclic_graph_list_query.properties.context.state.name, raw_context];
				}
				raw_type = raw_data
				break;
			}
			case 'acyclic graph tree query': {
				const $_acyclic_graph_tree_query = $_client_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_context: Record<string, any>;
					switch ($_acyclic_graph_tree_query.properties.context.state.name) {
						case 'does not exist': {
							const $_does_not_exist__context__acyclic_graph_tree_query = $_acyclic_graph_tree_query.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						case 'exists': {
							const $_exists__context__acyclic_graph_tree_query = $_acyclic_graph_tree_query.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["graph"] = serialize_graph_node($_exists__context__acyclic_graph_tree_query.properties.graph);
							raw_context = raw_data
							break;
						}
						case 'permission denied': {
							const $_permission_denied__context__acyclic_graph_tree_query = $_acyclic_graph_tree_query.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_acyclic_graph_tree_query.properties.context.state)
					}
					raw_data["context"] = [$_acyclic_graph_tree_query.properties.context.state.name, raw_context];
				}
				raw_type = raw_data
				break;
			}
			case 'collection query': {
				const $_collection_query = $_client_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_context: Record<string, any>;
					switch ($_collection_query.properties.context.state.name) {
						case 'does not exist': {
							const $_does_not_exist__context__collection_query = $_collection_query.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						case 'exists': {
							const $_exists__context__collection_query = $_collection_query.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							const raw_aggregates: Record<string, any> = {};
							for (let [k,v] of $_exists__context__collection_query.properties.aggregates) {
								const $_aggregates = v;
								const raw_data: Record<string, any> = {};
								{
									let raw_type: Record<string, any>;
									switch ($_aggregates.properties.type.state.name) {
										case 'state distribution': {
											const $_state_distribution = $_aggregates.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											const raw_states: Record<string, any> = {};
											for (let [k,v] of $_state_distribution.properties.states) {
												const $_states = v;
												const raw_data: Record<string, any> = {};
												raw_data["amount"] = $_states.properties.amount.value;
												raw_states[k] = raw_data
											}
											raw_data["states"] = raw_states;
											raw_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_aggregates.properties.type.state)
									}
									raw_data["type"] = [$_aggregates.properties.type.state.name, raw_type];
								}
								raw_aggregates[k] = raw_data
							}
							raw_data["aggregates"] = raw_aggregates;
							raw_data["amount of entries"] = $_exists__context__collection_query.properties.amount_of_entries.value;
							{
								let raw_entries: Record<string, any>;
								switch ($_exists__context__collection_query.properties.entries.state.name) {
									case 'no': {
										const $_no__entries = $_exists__context__collection_query.properties.entries.state.node;
										const raw_data: Record<string, any> = {};
										raw_entries = raw_data
										break;
									}
									case 'yes': {
										const $_yes__entries = $_exists__context__collection_query.properties.entries.state.node;
										const raw_data: Record<string, any> = {};
										raw_data["entries"] = serialize_collection_query_entries($_yes__entries.properties.entries);
										{
											let raw_limit_exceeded: Record<string, any>;
											switch ($_yes__entries.properties.limit_exceeded.state.name) {
												case 'no': {
													const $_no__limit_exceeded = $_yes__entries.properties.limit_exceeded.state.node;
													const raw_data: Record<string, any> = {};
													raw_limit_exceeded = raw_data
													break;
												}
												case 'yes': {
													const $_yes__limit_exceeded = $_yes__entries.properties.limit_exceeded.state.node;
													const raw_data: Record<string, any> = {};
													raw_limit_exceeded = raw_data
													break;
												}
												default:
													throw new Error("unexpected state: " + $_yes__entries.properties.limit_exceeded.state)
											}
											raw_data["limit exceeded"] = [$_yes__entries.properties.limit_exceeded.state.name, raw_limit_exceeded];
										}
										raw_entries = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_exists__context__collection_query.properties.entries.state)
								}
								raw_data["entries"] = [$_exists__context__collection_query.properties.entries.state.name, raw_entries];
							}
							raw_context = raw_data
							break;
						}
						case 'permission denied': {
							const $_permission_denied__context__collection_query = $_collection_query.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_collection_query.properties.context.state)
					}
					raw_data["context"] = [$_collection_query.properties.context.state.name, raw_context];
				}
				raw_type = raw_data
				break;
			}
			case 'command execution': {
				const $_command_execution = $_client_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'mutation': {
				const $_mutation = $_client_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_context: Record<string, any>;
					switch ($_mutation.properties.context.state.name) {
						case 'does not exist': {
							const $_does_not_exist__context__mutation = $_mutation.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						case 'exists': {
							const $_exists__context__mutation = $_mutation.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_result: Record<string, any>;
								switch ($_exists__context__mutation.properties.result.state.name) {
									case 'failure': {
										const $_failure__result__exists__context = $_exists__context__mutation.properties.result.state.node;
										const raw_data: Record<string, any> = {};
										raw_result = raw_data
										break;
									}
									case 'success': {
										const $_success__result__exists__context = $_exists__context__mutation.properties.result.state.node;
										const raw_data: Record<string, any> = {};
										raw_result = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_exists__context__mutation.properties.result.state)
								}
								raw_data["result"] = [$_exists__context__mutation.properties.result.state.name, raw_result];
							}
							raw_context = raw_data
							break;
						}
						case 'permission denied': {
							const $_permission_denied__context__mutation = $_mutation.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_mutation.properties.context.state)
					}
					raw_data["context"] = [$_mutation.properties.context.state.name, raw_context];
				}
				raw_type = raw_data
				break;
			}
			case 'notification': {
				const $_notification = $_client_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_context: Record<string, any>;
					switch ($_notification.properties.context.state.name) {
						case 'does not exist': {
							const $_does_not_exist__context__notification = $_notification.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						case 'exists': {
							const $_exists__context__notification = $_notification.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["notification data"] = serialize_notification_data($_exists__context__notification.properties.notification_data);
							raw_context = raw_data
							break;
						}
						case 'permission denied': {
							const $_permission_denied__context__notification = $_notification.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_notification.properties.context.state)
					}
					raw_data["context"] = [$_notification.properties.context.state.name, raw_context];
				}
				raw_type = raw_data
				break;
			}
			case 'password mutation': {
				const $_password_mutation = $_client_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_user_context: Record<string, any>;
					switch ($_password_mutation.properties.user_context.state.name) {
						case 'does not exist': {
							const $_does_not_exist__user_context__password_mutation = $_password_mutation.properties.user_context.state.node;
							const raw_data: Record<string, any> = {};
							raw_user_context = raw_data
							break;
						}
						case 'exists': {
							const $_exists__user_context__password_mutation = $_password_mutation.properties.user_context.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_result: Record<string, any>;
								switch ($_exists__user_context__password_mutation.properties.result.state.name) {
									case 'failure': {
										const $_failure__result__exists__user_context__password_mutation = $_exists__user_context__password_mutation.properties.result.state.node;
										const raw_data: Record<string, any> = {};
										raw_result = raw_data
										break;
									}
									case 'success': {
										const $_success__result__exists__user_context__password_mutation = $_exists__user_context__password_mutation.properties.result.state.node;
										const raw_data: Record<string, any> = {};
										raw_result = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_exists__user_context__password_mutation.properties.result.state)
								}
								raw_data["result"] = [$_exists__user_context__password_mutation.properties.result.state.name, raw_result];
							}
							raw_user_context = raw_data
							break;
						}
						case 'permission denied': {
							const $_permission_denied__user_context__password_mutation = $_password_mutation.properties.user_context.state.node;
							const raw_data: Record<string, any> = {};
							raw_user_context = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_password_mutation.properties.user_context.state)
					}
					raw_data["user context"] = [$_password_mutation.properties.user_context.state.name, raw_user_context];
				}
				raw_type = raw_data
				break;
			}
			case 'password reset': {
				const $_password_reset = $_client_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_user_context: Record<string, any>;
					switch ($_password_reset.properties.user_context.state.name) {
						case 'does not exist': {
							const $_does_not_exist__user_context__password_reset = $_password_reset.properties.user_context.state.node;
							const raw_data: Record<string, any> = {};
							raw_user_context = raw_data
							break;
						}
						case 'exists': {
							const $_exists__user_context__password_reset = $_password_reset.properties.user_context.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_result: Record<string, any>;
								switch ($_exists__user_context__password_reset.properties.result.state.name) {
									case 'failure': {
										const $_failure__result__exists__user_context__password_reset = $_exists__user_context__password_reset.properties.result.state.node;
										const raw_data: Record<string, any> = {};
										raw_result = raw_data
										break;
									}
									case 'success': {
										const $_success__result__exists__user_context__password_reset = $_exists__user_context__password_reset.properties.result.state.node;
										const raw_data: Record<string, any> = {};
										raw_data["temporary password"] = $_success__result__exists__user_context__password_reset.properties.temporary_password;
										raw_result = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_exists__user_context__password_reset.properties.result.state)
								}
								raw_data["result"] = [$_exists__user_context__password_reset.properties.result.state.name, raw_result];
							}
							raw_user_context = raw_data
							break;
						}
						case 'permission denied': {
							const $_permission_denied__user_context__password_reset = $_password_reset.properties.user_context.state.node;
							const raw_data: Record<string, any> = {};
							raw_user_context = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_password_reset.properties.user_context.state)
					}
					raw_data["user context"] = [$_password_reset.properties.user_context.state.name, raw_user_context];
				}
				raw_type = raw_data
				break;
			}
			case 'subscription': {
				const $_subscription = $_client_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_context: Record<string, any>;
					switch ($_subscription.properties.context.state.name) {
						case 'does not exist': {
							const $_does_not_exist__context__subscription = $_subscription.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						case 'exists': {
							const $_exists__context__subscription = $_subscription.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["delete permitted"] = serialize_permission_data($_exists__context__subscription.properties.delete_permitted);
							raw_data["subscription result data"] = serialize_subscription_result_data($_exists__context__subscription.properties.subscription_result_data);
							raw_context = raw_data
							break;
						}
						case 'permission denied': {
							const $_permission_denied__context__subscription = $_subscription.properties.context.state.node;
							const raw_data: Record<string, any> = {};
							raw_context = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_subscription.properties.context.state)
					}
					raw_data["context"] = [$_subscription.properties.context.state.name, raw_context];
				}
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_reply.properties.type.state)
		}
		raw_data["type"] = [$_client_reply.properties.type.state.name, raw_type];
	}
	return raw_data;
}